import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./AppCustomProperties.css";
import { AppCustomPropertyNew } from "./AppCustomPropertyNew";
import { CustomProperty } from "winslow-core";
import { apiGetCustomPropertiesForWorkspace } from "../../../services/EmployeeRecordService";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import toast from "react-hot-toast";
import { SETTINGS_COMPONENTS } from "./AppCustomPropertyNew";

type AppCustomPropertiesProps = {

}   

export const AppCustomProperties = ({} : AppCustomPropertiesProps) => {

    const storeUser = useSelector(selectUser);
    
    const { customPropertyId } = useParams();   // id or "new"
    const navigate = useNavigate();

    const [customProperties, setCustomProperties] = useState<CustomProperty[] | undefined>(undefined);

    useEffect(() => {
        if (!customProperties) {
            (async () => {
                const cps = await apiGetCustomPropertiesForWorkspace(storeUser?.currentWorkspaceId || "");

                if (!cps) {
                    toast("Error loading custom properties");
                    return;
                }

                setCustomProperties(cps);
            })();
        }
    },[]);
        
    useEffect(() => {
        console.log("[AppCustomProperties] id: ", customPropertyId);
    }, [customPropertyId]);

    return (
        <div className="app-custom-properties">
            {customPropertyId === "new" &&
                <AppCustomPropertyNew />
            }
            {customPropertyId !== "new" && customProperties &&
            
                <div className="app-custom-properties-contents">
                    <div className="app-custom-properties-actions">
                        <button
                            className="button-save"
                            onClick={() => {
                                navigate("/app/custom-properties/new");
                            }}
                        >
                            Add
                        </button>
                    </div>
                    <div className="app-custom-properties-grid-container">
                        <div className="app-custom-properties-grid-header">
                            <div>Select</div>
                            <div>Name</div>
                            <div>Type</div>
                            <div>Required</div>
                            <div>Hidden</div>
                            <div>Roles</div>
                            <div>Description</div>
                        </div>
                        {customProperties.map((cp) => {
                            return (
                                <div 
                                    key={cp.id}
                                    className="app-custom-properties-grid-row"
                                >
                                    <div className="app-custom-properties-grid-cell">
                                        <input type="checkbox" />
                                    </div>
                                    <div className="app-custom-properties-grid-cell">
                                        <div 
                                            className="app-custom-properties-grid-display"
                                            onClick={()=> {
                                                navigate(`/app/custom-properties/update/${cp.id}`);
                                            }}
                                        >
                                            {cp.display}
                                        </div>
                                    </div>
                                    <div className="app-custom-properties-grid-cell">
                                        {SETTINGS_COMPONENTS[cp.type]}
                                    </div>
                                    <div className="app-custom-properties-grid-cell">
                                        {cp.required ? "Required" : "Optional"}
                                    </div>
                                    <div className="app-custom-properties-grid-cell">
                                        {cp.hidden ? "Hidden" : "Visible"}
                                    </div>
                                    <div className="app-custom-properties-grid-cell">
                                        {cp.visibleRoles.map((role, index) => {
                                            return (
                                                <span key={role}>
                                                    {role}{index < cp.visibleRoles.length -1 ? ", " : ""}
                                                </span>
                                            )
                                        })}
                                    </div>

                                    <div className="app-custom-properties-grid-cell">
                                        {cp.description}
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    
                </div>
            }
        </div>
    )
}